import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { reducer as formReducer } from 'redux-form';
import * as Auth from './common/auth/store.js';
import * as TermsAndConditions from './common/termsAndConditions/store.js';
import * as Ajax from './common/ajax/store.js';
import * as Localisation from './common/localisation/store.js';
import * as CustomerDetails from './customerDetails/store.js';
import * as AccountSelections from './accountSelection/store.js';
import * as Transactions from './transactions/store.js';
import * as Test from './addAccount/store.js';
import * as Profile from './profile/store.js';
import * as TaxInvoices from './taxInvoices/store.js';
import * as Settings from './common/setting/store.js';

export function getRootReducer() {
  return combineReducers({
    form: formReducer,
    auth: Auth.reducer,
    ajax: Ajax.reducer,
    localisation: Localisation.reducer,
    termsAndConditions: TermsAndConditions.reducer,
    customerDetails: CustomerDetails.reducer,
    accountSelection: AccountSelections.reducer,
    transactions: Transactions.reducer,
    profile: Profile.reducer,
    test: Test.reducer,
    taxInvoices: TaxInvoices.reducer,
    settings: Settings.reducer,
  });
}

export default function configureStore() {
  const middleware = [thunk];

  // In development, use the browser's Redux dev tools extension if installed
  const enhancers = [];
  const isDevelopment = process.env.NODE_ENV === 'development';
  if (
    isDevelopment &&
    typeof window !== 'undefined' &&
    window.devToolsExtension
  ) {
    enhancers.push(window.devToolsExtension());
  }

  return createStore(
    getRootReducer(),
    compose(applyMiddleware(...middleware), ...enhancers)
  );
}
